export const fetchPermissionToken = async (
  token: string,
  authUrl: RequestInfo | URL
): Promise<{
  upgraded: boolean;
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  'not-before-policy': number;
}> => {
  const requestBody = new URLSearchParams();
  requestBody.append(
    'grant_type',
    'urn:ietf:params:oauth:grant-type:uma-ticket'
  );
  requestBody.append('audience', 'vindr-api');
  requestBody.append('permission', 'api');

  // scopes.map(it => {
  //   requestBody.append('permission', `api#${it}`);
  // });

  const response = await fetch(authUrl, {
    method: 'POST',
    body: requestBody,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

export const refreshToken = async (refreshToken = '', authUrl) => {
  const requestBody = new URLSearchParams();
  requestBody.append('grant_type', 'refresh_token');
  requestBody.append(
    'client_id',
    (window?.config?.oauth?.[0] || window?.config?.oidc?.[0])?.client_id
  );
  requestBody.append('refresh_token', refreshToken);
  requestBody.append(
    'redirect_uri',
    (window?.config?.oauth?.[0] || window?.config?.oidc?.[0])?.redirect_uri ||
      window.location.origin
  );

  const response = await fetch(authUrl, {
    method: 'POST',
    body: requestBody,
  });

  return response.json();
};

export const fetchUserInfo = async token => {
  const response = await fetch(window?.config?.risURL + '/users/v1/profile', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.json();
};

export const fetchRelatedStudies = async (
  relatedInfo = '',
  authHeader,
  withParams = false
) => {
  return fetch(
    window?.config?.risURL +
      '/related-studylist' +
      (withParams ? `?${relatedInfo}` : ''),
    {
      method: 'GET',
      headers: {
        ...authHeader,
        'X-PARAMS': relatedInfo,
      },
    }
  ).then(res => res.json());
};

export const fetchConsultationStudies = async (
  id = '',
  authHeader
  // withParams = false
) => {
  return fetch(
    window?.config?.risURL.replace('/ris', '') +
      `/consultation/v1/studies?meeting_id=${id}`,
    {
      method: 'GET',
      headers: {
        ...authHeader,
        // 'X-PARAMS': relatedInfo,
      },
    }
  ).then(res => res.json());
};

export const verifyHash = async (
  relatedInfo = '',
  authHeader,
  withParams = false
) => {
  return fetch(
    window?.config?.risURL +
      '/verify-hash' +
      (withParams ? `?${relatedInfo}` : ''),
    {
      method: 'GET',
      headers: {
        ...authHeader,
        'X-PARAMS': relatedInfo,
      },
    }
  ).then(res => res.status === 200);
};

export const fetchHashPermissions = async (relatedInfo = '') => {
  const params = new URLSearchParams(relatedInfo);
  const appId = params.get('app_id');
  return fetch(window?.config?.risURL + `/app-key/permissions/${appId}`, {
    method: 'GET',
    headers: {
      // ...authHeader,
      'X-PARAMS': relatedInfo,
    },
  }).then(res => res.json());
};

export const verifyEncrypted = async (p: string) => {
  const params = new URLSearchParams(p);
  const paramsString = params.toString();
  return fetch(
    window?.config?.risURL.replace('/api/ris', '') +
      `/aes-encrypted?${paramsString}`
  ).then(res => res.json());
};
